module.exports = __webpack_public_path__ + "static/media/calendar_02.ad9c1736.png";